export const URL = '/v1/auth/reset-password/'

export type Req = { email: string }

export type Resp = {
  success: boolean
}
